import {Link, Route} from 'react-router-dom';
import React from 'react';
import AuthMiddleware from '../middleware/AuthMiddleware';
import {useSelector} from "react-redux";
import {checkPermission} from "./RouteValidator";
import CreateCustomer from "../../modules/customer/CreateCustomer";
import ManageCustomers from "../../modules/customer/ManageCustomers";
import UpdateCustomer from "../../modules/customer/UpdateCustomer";

const GenerateCustomerModuleRoutes = () => {
    const company = useSelector((state: any) => state.company);
    const auth = useSelector((state: any) => state.auth);

    const routes: any = [];

    if (checkPermission(auth, company, '/customers/add')) {
        routes.push(
            <Route path={'/customers/add'} element={
                <AuthMiddleware children={<CreateCustomer/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/customers')) {
        routes.push(
            <Route path={'/customers'} element={
                <AuthMiddleware children={<ManageCustomers/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/customers/details/id')) {
        routes.push(
            <Route path={'/customers/details/:id'} element={
                <AuthMiddleware children={<UpdateCustomer/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/vendors/add')) {
        routes.push(
            <Route path={'/vendors/add'} element={
                <AuthMiddleware children={<CreateCustomer/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/vendors')) {
        routes.push(
            <Route path={'/vendors'} element={
                <AuthMiddleware children={<ManageCustomers/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/vendors/details/id')) {
        routes.push(
            <Route path={'/vendors/details/:id'} element={
                <AuthMiddleware children={<UpdateCustomer/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/transporters/add')) {
        routes.push(
            <Route path={'/transporters/add'} element={
                <AuthMiddleware children={<CreateCustomer/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/transporters')) {
        routes.push(
            <Route path={'/transporters'} element={
                <AuthMiddleware children={<ManageCustomers/>}/>
            }/>
        );
    }

    if (checkPermission(auth, company, '/transporters/details/id')) {
        routes.push(
            <Route path={'/transporters/details/:id'} element={
                <AuthMiddleware children={<UpdateCustomer/>}/>
            }/>
        );
    }

    return routes;
}

export default GenerateCustomerModuleRoutes;
